import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaLock, FaSignInAlt, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

const RoasterLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [popup, setPopup] = useState({ show: false, success: false, message: "" });
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();

   const users = [
  { email: "roaster@ricgop.online", password: "roaster123", role: "Roaster" },
  { email: "fire@ricgop.online", password: "fire123", role: "Fire" },
  { email: "radiology@ricgop.online", password: "radiology123", role: "Radiology" },
];


    const user = users.find((u) => u.email === email && u.password === password);

    if (user) {
      setPopup({ show: true, success: true, message: "Login successful!" });
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("loggedIn", "true");
      setIsLoggedIn(true);

      setTimeout(() => setPopup({ show: false }), 1500);
    } else {
      setPopup({ show: true, success: false, message: "Invalid email or password." });
      setTimeout(() => setPopup({ show: false }), 2000);
    }
  };

  const handleContinue = () => {
    navigate("/entry/roaster/dutyform");
  };

  return (
    <div className="login-page">
      {popup.show && (
        <div className={`popup-toast ${popup.success ? "success" : "error"}`}>
          {popup.success ? <FaCheckCircle className="icon" /> : <FaTimesCircle className="icon" />}
          <span>{popup.message}</span>
        </div>
      )}

      <div className="login-card shadow">
        <div className="text-center mb-4">
          <FaSignInAlt size={40} className="text-primary mb-2" />
          <h3 className="fw-bold text-primary">Roaster Login</h3>
          <p className="text-muted">Login to manage duty roaster</p>
        </div>

        {!isLoggedIn ? (
          <form onSubmit={handleLogin}>
            <div className="form-group mb-3">
              <label className="form-label fw-semibold">
                <FaUser className="me-2" /> Email
              </label>
              <input
                type="email"
                className="form-control form-control-lg rounded-4"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter Email"
                required
              />
            </div>
            <div className="form-group mb-4">
              <label className="form-label fw-semibold">
                <FaLock className="me-2" /> Password
              </label>
              <input
                type="password"
                className="form-control form-control-lg rounded-4"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter Password"
                required
              />
            </div>
            <div className="d-grid">
              <button className="btn btn-primary btn-lg rounded-4 shadow-sm" type="submit">
                <FaSignInAlt className="me-2" /> Login
              </button>
            </div>
          </form>
        ) : (
          <div className="text-center mt-4">
            <button className="btn btn-success btn-lg rounded-4 shadow-sm" onClick={handleContinue}>
              ✅ Continue to Duty Form
            </button>
          </div>
        )}

        <div className="text-center text-muted mt-4 small">
          © {new Date().getFullYear()} Rawalpindi Institute of Cardiology
        </div>
      </div>

      <style>{`
        .login-page {
          height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #e0f7fa, #f1f8ff);
          font-family: 'Segoe UI', sans-serif;
        }

        .login-card {
          width: 400px;
          padding: 40px;
          background: #fff;
          border-radius: 30px;
          position: relative;
          animation: fadeIn 0.6s ease-in-out;
        }

        .popup-toast {
          position: absolute;
          top: 20px;
          left: 50%;
          transform: translateX(-50%);
          background: #fff;
          padding: 12px 20px;
          border-radius: 20px;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
          display: flex;
          align-items: center;
          gap: 10px;
          z-index: 9999;
          font-weight: 600;
        }

        .popup-toast.success {
          color: #198754;
          border: 2px solid #198754;
        }

        .popup-toast.error {
          color: #dc3545;
          border: 2px solid #dc3545;
        }

        .popup-toast .icon {
          font-size: 1.5rem;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default RoasterLogin;
